import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';

export const exportUserReportToPDF = (users, reportTitle = 'User Report') => {
  try {
    if (!users || !Array.isArray(users) || users.length === 0) {
      alert('No user data available to export');
      return;
    }

    const doc = new jsPDF();
    
    // Add title
    doc.setFontSize(20);
    doc.text('Access70 LMS', 20, 20);
    
    doc.setFontSize(16);
    doc.text(reportTitle, 20, 35);
    
    // Add generation date
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 20, 45);
    
    // Prepare table data with safe property access
    const tableColumn = ['Name', 'Email', 'Role', 'Status', 'Enrolled Date'];
    const tableRows = users.map(user => [
      (user && user.displayName) || 'N/A',
      (user && user.email) || 'N/A',
      (user && user.role) || 'N/A',
      (user && user.status) || 'N/A',
      (user && user.enrolledDate) ? new Date(user.enrolledDate).toLocaleDateString() : 'N/A'
    ]);
    
    // Add table
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 55,
      styles: {
        fontSize: 8,
        cellPadding: 3,
      },
      headStyles: {
        fillColor: [22, 160, 133],
        textColor: 255,
        fontSize: 9,
        fontStyle: 'bold',
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
    });
    
    // Add footer
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(8);
    doc.text('Access70 LMS', 20, pageHeight - 10);
    
    // Save the PDF
    const filename = `${reportTitle.replace(/\s+/g, '_').toLowerCase()}_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(filename);
    
  } catch (error) {
    console.error('Error generating PDF:', error);
    alert('Error generating PDF report. Please try again.');
  }
};

export const exportIssueReportToPDF = (issues, reportTitle = 'Issue Report') => {
  try {
    if (!issues || !Array.isArray(issues) || issues.length === 0) {
      alert('No issue data available to export');
      return;
    }

    const doc = new jsPDF();
    
    // Add title
    doc.setFontSize(20);
    doc.text('Access70 LMS', 20, 20);
    
    doc.setFontSize(16);
    doc.text(reportTitle, 20, 35);
    
    // Add generation date
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 20, 45);
    
    // Prepare table data with safe property access
    const tableColumn = ['ID', 'Title', 'Priority', 'Status', 'Reporter', 'Created Date'];
    const tableRows = issues.map(issue => [
      (issue && issue.id) || 'N/A',
      (issue && issue.title) || 'N/A',
      (issue && issue.priority) || 'N/A',
      (issue && issue.status) || 'N/A',
      (issue && issue.reportedByName) || 'N/A',
      (issue && issue.createdAt) ? new Date(issue.createdAt).toLocaleDateString() : 'N/A'
    ]);
    
    // Add table
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 55,
      styles: {
        fontSize: 8,
        cellPadding: 3,
      },
      headStyles: {
        fillColor: [22, 160, 133],
        textColor: 255,
        fontSize: 9,
        fontStyle: 'bold',
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
    });
    
    // Add footer
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(8);
    doc.text('Access70 LMS', 20, pageHeight - 10);
    
    // Save the PDF
    const filename = `${reportTitle.replace(/\s+/g, '_').toLowerCase()}_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(filename);
    
  } catch (error) {
    console.error('Error generating PDF:', error);
    alert('Error generating PDF report. Please try again.');
  }
};

export const exportAttendanceReportToPDF = (attendanceData, reportTitle = 'Attendance Report') => {
  try {
    if (!attendanceData || !Array.isArray(attendanceData) || attendanceData.length === 0) {
      alert('No attendance data available to export');
      return;
    }

    const doc = new jsPDF();
    
    // Add title
    doc.setFontSize(20);
    doc.text('Access70 LMS', 20, 20);
    
    doc.setFontSize(16);
    doc.text(reportTitle, 20, 35);
    
    // Add generation date
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 20, 45);
    
    // Prepare table data with safe property access
    const tableColumn = ['Learner Name', 'Email', 'Module', 'Date', 'Status'];
    const tableRows = attendanceData.map(record => [
      (record && record.learnerName) || 'N/A',
      (record && record.email) || 'N/A',
      (record && record.module) || 'N/A',
      (record && record.date) ? new Date(record.date).toLocaleDateString() : 'N/A',
      (record && record.status) || 'N/A'
    ]);
    
    // Add table
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 55,
      styles: {
        fontSize: 8,
        cellPadding: 3,
      },
      headStyles: {
        fillColor: [22, 160, 133],
        textColor: 255,
        fontSize: 9,
        fontStyle: 'bold',
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
    });
    
    // Add footer
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(8);
    doc.text('Access70 LMS', 20, pageHeight - 10);
    
    // Save the PDF
    const filename = `${reportTitle.replace(/\s+/g, '_').toLowerCase()}_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(filename);
    
  } catch (error) {
    console.error('Error generating PDF:', error);
    alert('Error generating PDF report. Please try again.');
  }
};

export const exportAnalyticsReportToPDF = (analyticsData, reportTitle = 'Analytics Report') => {
  try {
    if (!analyticsData || typeof analyticsData !== 'object') {
      alert('No analytics data available to export');
      return;
    }

    const doc = new jsPDF();
    
    // Add title
    doc.setFontSize(20);
    doc.text('Access70 LMS', 20, 20);
    
    doc.setFontSize(16);
    doc.text(reportTitle, 20, 35);
    
    // Add generation date
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 20, 45);
    
    // Add summary statistics
    let yPosition = 65;
    doc.setFontSize(12);
    doc.text('Summary Statistics:', 20, yPosition);
    yPosition += 10;
    
    doc.setFontSize(10);
    if (analyticsData.totalUsers) {
      doc.text(`Total Users: ${analyticsData.totalUsers}`, 20, yPosition);
      yPosition += 8;
    }
    if (analyticsData.activeUsers) {
      doc.text(`Active Users: ${analyticsData.activeUsers}`, 20, yPosition);
      yPosition += 8;
    }
    if (analyticsData.completionRate) {
      doc.text(`Overall Completion Rate: ${analyticsData.completionRate}%`, 20, yPosition);
      yPosition += 8;
    }
    if (analyticsData.avgProgress) {
      doc.text(`Average Progress: ${analyticsData.avgProgress}%`, 20, yPosition);
      yPosition += 8;
    }
    
    // Add detailed data if available
    if (analyticsData.detailedData && Array.isArray(analyticsData.detailedData) && analyticsData.detailedData.length > 0) {
      yPosition += 10;
      
      const tableColumn = ['Metric', 'Value', 'Category', 'Date'];
      const tableRows = analyticsData.detailedData.map(item => [
        (item && item.metric) || 'N/A',
        (item && item.value) || 'N/A',
        (item && item.category) || 'N/A',
        (item && item.date) ? new Date(item.date).toLocaleDateString() : 'N/A'
      ]);
      
      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: yPosition,
        styles: {
          fontSize: 8,
          cellPadding: 3,
        },
        headStyles: {
          fillColor: [22, 160, 133],
          textColor: 255,
          fontSize: 9,
          fontStyle: 'bold',
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245],
        },
      });
    }
    
    // Add footer
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(8);
    doc.text('Access70 LMS', 20, pageHeight - 10);
    
    // Save the PDF
    const filename = `${reportTitle.replace(/\s+/g, '_').toLowerCase()}_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(filename);
    
  } catch (error) {
    console.error('Error generating PDF:', error);
    alert('Error generating PDF report. Please try again.');
  }
};